export const phoneRegExp = /^(\+\d{1,3}[- ]?)?\d{10}$/;
